import axios from 'axios'

export default (withCredentials = false) => {
  const options = {
    baseURL: process.env.VUE_APP_CUSTOMER_PANEL_API_URL
  }
  if (withCredentials) options.withCredentials = true
  return axios.create(options)
}
